import React, { ComponentPropsWithoutRef } from 'react'
import { Check } from '~shared/icons/check'
import { cn } from '~shared/utils/cn'

export interface AdvantagesSectionProps extends ComponentPropsWithoutRef<'section'> {}

export const AdvantagesSection: React.FC<AdvantagesSectionProps> = props => {
  const { className = '' } = props

  const advantages = [
    { id: 1, name: 'Прием иностранных граждан' },
    { id: 2, name: 'Дистанционное обучение. Можете учиться из своего региона' },
    { id: 3, name: 'Государственный диплом, востребованный по всему миру' },
    { id: 4, name: 'Сильный профессорский состав и практикующие преподаватели' },
    { id: 5, name: 'Рассрочка от института без переплат' }
  ]

  return (
    <section className={cn('container container-slim mt-[8px]', className)}>
      <div
        className='p-[16px] lg:px-[40px] lg:py-[24px] xl:px-[48px] xl:py-[40px] bg-[#F2F2F2] rounded-[24px] grid
         gap-[16px]  lg:gap-[41px]
         md:grid-cols-[1fr_1fr_1fr] md:gap-[24px]
         lg:grid-cols-[0.5fr_1fr_1fr_1fr_0.5fr] lg: items-center
         2xl:grid-cols-[0.7fr_1fr_1fr_1fr_0.7fr]'>
        {advantages.map(el => (
          <div
            className='flex gap-[14px] lg:gap-[8px] xl:gap-[16px]'
            key={el.id}>
            <span className='mt-[2px]'>
              <Check />
            </span>
            <p className='text-[14px] xl:text-[16px] tracking-[-0.8px]'>
              {el.name}
            </p>
          </div>
        ))}
      </div>
    </section>
  )
}
